export default __webpack_public_path__ + "static/3-f288f2bf7486ec6fb2bb3cadcc0bb797.jpg";